import React,{useEffect} from 'react';
import {AppStoreButton,PlayStoreButton} from '../components/StoreButtons';

const APP_STORE_URL='https://apps.apple.com/us/app/wingcue-your-ai-wingman/id6806146653';
const PLAY_STORE_URL='https://play.google.com/store/apps/details?id=com.rork.wingcue&pli=1';

const Home=()=> {
  useEffect(()=> {
    const userAgent=navigator.userAgent || navigator.vendor || '';
    const isAndroid=/android/i.test(userAgent);
    const isIOS=/iPad|iPhone|iPod/i.test(userAgent)
      || (navigator.platform==='MacIntel' && navigator.maxTouchPoints > 1);

    if (isAndroid) {
      window.location.replace(PLAY_STORE_URL);
      return;
    }

    if (isIOS) {
      window.location.replace(APP_STORE_URL);
    }
  },[]);

  return (
    <div className="flex flex-col w-full">
      <section className="relative flex flex-col items-center justify-center min-h-screen px-6 text-center overflow-hidden">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{background: 'radial-gradient(ellipse 80% 60% at 50% 0%,rgba(233,78,52,0.18) 0%,transparent 70%)'}}
        />
        <div
          className="absolute inset-0 pointer-events-none opacity-[0.03]"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.8) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.8) 1px,transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative z-10 flex flex-col items-center">
          <div className="mb-6 inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#E94E34] animate-pulse" />
            <span className="text-xs font-semibold text-white/50 tracking-widest uppercase">
              #1 AI Dating Assistant
            </span>
          </div>
          <div className="mb-8 relative w-28 h-28 rounded-[28px] overflow-hidden glow-brand">
            <img
              src="https://global.divhunt.com/98cbfb556909c496f5e20fefb9d9b7b7_5355.avif"
              alt="Wingcue"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
          <h1 className="text-6xl md:text-8xl font-black tracking-tighter text-white mb-12 leading-none">
            WING<span className="text-gradient">CUE</span>
          </h1>
          <div className="flex flex-col gap-4 items-center">
            <AppStoreButton />
            <PlayStoreButton />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent pointer-events-none" />
      </section>
    </div>
  );
};

export default Home;